"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_query_1 = require("@tanstack/react-query");
const lexico_1 = __importDefault(require("@tradeshift/lexico"));
const axios_1 = __importDefault(require("axios"));
const classnames_1 = __importDefault(require("classnames"));
const lodash_1 = __importDefault(require("lodash"));
const pino_1 = __importDefault(require("pino"));
const react_1 = require("react");
const react_router_1 = require("react-router");
const react_use_1 = require("react-use");
const shallow_1 = require("zustand/shallow");
const appConstants_1 = require("../../../constants/appConstants");
const strings_1 = require("../../../constants/strings");
const uiConstants_1 = require("../../../constants/uiConstants");
const approvalQuery_1 = require("../../../queries/approvals/approvalQuery");
const sessionQuery_1 = require("../../../queries/sessionQuery");
const teamQuery_1 = require("../../../queries/teamQuery");
const userQuery_1 = require("../../../queries/userQuery");
const configRepository_1 = require("../../../repositories/configRepository");
const conversationRepository_1 = require("../../../repositories/conversationRepository");
const sessionRepository_1 = require("../../../repositories/sessionRepository");
const setTime_1 = require("../../../utils/setTime");
const zustandStore_1 = require("../../../zustandStore");
const sideMenuFooter_1 = __importDefault(require("./sideMenuFooter"));
const sideMenuHeader_1 = __importDefault(require("./sideMenuHeader"));
const sideMenuMyRequestAside_1 = __importDefault(require("./sideMenuMyRequestAside"));
const sideMenuPanel_1 = __importDefault(require("./sideMenuPanel"));
const sideMenuTeamSwitcher_1 = __importDefault(require("./sideMenuTeamSwitcher"));
require("./style.less");
const UserDetailsAside = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('../../organisms/userDetailsAside'))));
const lexico = new lexico_1.default();
const logger = (0, pino_1.default)();
const VERSION = configRepository_1.ConfigRepository.get('VERSION');
const fetchAndUpdateStream = async (user, stopInterval, signal) => {
    try {
        if (!user['userId']) {
            stopInterval();
            return;
        }
        const { setStreamData, setCurrentStreamData } = zustandStore_1.useZustand.getState();
        const { currentStreamData, initialAfter } = zustandStore_1.useZustand.getState().stream;
        const response = await conversationRepository_1.ConversationRepository.getStream({
            after: currentStreamData.lastTimestamp || initialAfter,
            signal,
        });
        if (!lodash_1.default.isEmpty(response.events)) {
            setCurrentStreamData(response);
        }
        if (response.lastTimestamp && response.events.length > 0) {
            const streamData = zustandStore_1.useZustand.getState().stream.streamData;
            const newData = {
                ...streamData,
                events: [...streamData.events, ...response.events],
            };
            setStreamData(newData);
            void (0, approvalQuery_1.updateApprovalsData)(user, response.events);
        }
    }
    catch (error) {
        if (error instanceof Error && axios_1.default.isAxiosError(error) && error.status === 403) {
            if (!globalThis.IS_PLAYWRIGHT_RUNNING) {
                // prevent redirecting to login page when running playwright tests
                void sessionRepository_1.SessionRepository.logout();
                globalThis.location.href = '/signin/login?inactivityLogout=true';
            }
            logger.info('User does not have permission to access stream');
            return;
        }
        if (error instanceof Error && error.name === 'AbortError') {
            logger.info('Fetch request was aborted');
            stopInterval();
            return;
        }
        logger.error({ message: 'Error in fetching stream:', error });
        stopInterval();
    }
};
const fetchServerVersion = async (setDialog, closeDialog, stopInterval) => {
    const serverVersion = await configRepository_1.ConfigRepository.getServerVersion();
    if (VERSION !== serverVersion) {
        stopInterval();
        let countdown = 10;
        const countdownInterval = setInterval(() => {
            setDialog({
                message: `${lexico.tr("Sorry! We're having trouble connecting at the moment - retrying in")} ${countdown} ${lexico.tr('seconds')}.`,
                type: strings_1.notificationStrings.WARNING,
                open: true,
                actionText: lexico.trc('Retry Message', 'Retry connection now'),
                onAccept: () => {
                    closeDialog();
                    globalThis.location.reload();
                },
                showCancel: false,
            });
            countdown -= 1;
            if (countdown <= 0) {
                clearInterval(countdownInterval);
                globalThis.location.reload();
            }
        }, (0, setTime_1.setTime)(1, 'seconds'));
    }
};
const SideMenu = () => {
    const { isLoading, isSuccess } = (0, react_query_1.useQuery)(sessionQuery_1.authStatusQuery);
    const [openAside, setOpenAside] = (0, react_1.useState)(false);
    const isMobileWidth = (0, react_use_1.useMedia)('(max-width: 650px)');
    const { data: userData } = (0, react_query_1.useQuery)(userQuery_1.userQuery);
    const { data: userSelectedTeamData } = (0, react_query_1.useQuery)((0, teamQuery_1.selectedTeamIdQuery)('selectedTeamID'));
    const intervalRef = (0, react_1.useRef)(null);
    const abortControllerRef = (0, react_1.useRef)(null);
    const navigate = (0, react_router_1.useNavigate)();
    const { sideMenu, user: userDataFromZustand, setDialog, closeDialog, setUser, setNotification, setCompanyName, setCompanyId, setUserSelectedTeam, openSideMenuOnMobileView, } = (0, zustandStore_1.useZustand)((0, shallow_1.useShallow)(state => ({
        sideMenu: state.sideMenu,
        user: state.user,
        setDialog: state.setDialog,
        closeDialog: state.closeDialog,
        setUser: state.setUser,
        setNotification: state.setNotification,
        setCompanyName: state.setCompanyName,
        setCompanyId: state.setCompanyId,
        setUserSelectedTeam: state.setUserSelectedTeam,
        openSideMenuOnMobileView: state.openSideMenuOnMobileView,
    })));
    const { isOpenOnDesktopView, isOpenOnMobileView } = sideMenu;
    const shouldRender = !['/signin', '/tos', '/landing'].includes(globalThis.location.pathname);
    const logout = (0, sessionQuery_1.useSessionLogoutQuery)();
    const stopInterval = () => {
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
            abortControllerRef.current = null;
        }
    };
    const startInterval = () => {
        if (!userData?.userId) {
            stopInterval();
            return;
        }
        if (!intervalRef.current) {
            abortControllerRef.current = new AbortController();
            intervalRef.current = setInterval(async () => {
                try {
                    const results = await Promise.allSettled([
                        abortControllerRef.current
                            ? fetchAndUpdateStream(userData, stopInterval, abortControllerRef.current.signal)
                            : Promise.resolve(),
                        fetchServerVersion(setDialog, closeDialog, stopInterval),
                    ]);
                    results.forEach(result => {
                        if (result.status === 'rejected') {
                            const error = result.reason;
                            if (axios_1.default.isCancel(error)) {
                                logger.warn({ message: 'Request canceled', error: error.message });
                            }
                            else {
                                logger.error({ message: 'Error in fetching updates:', error });
                                if (!window['IS_PLAYWRIGHT_RUNNING'] &&
                                    axios_1.default.isAxiosError(error) &&
                                    error.response?.status === 401 &&
                                    !globalThis.location.pathname.includes('signin')) {
                                    setNotification([
                                        {
                                            type: strings_1.notificationStrings.ERROR,
                                            message: 'Your session has expired.\nYou will now be redirected to the login page.',
                                        },
                                    ]);
                                    setTimeout(() => {
                                        void navigate('/signin/login');
                                    }, (0, setTime_1.setTime)(2, 'seconds'));
                                }
                            }
                        }
                    });
                }
                catch (error) {
                    logger.error({ message: 'Unexpected error in fetching interval updates:', error });
                }
            }, (0, setTime_1.setTime)(2, 'seconds'));
        }
    };
    async function logoutApp() {
        try {
            await logout.mutateAsync();
        }
        catch (error) {
            logger.error({ message: 'Error in logging out', error });
        }
        finally {
            void navigate('/signin/login', globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                ? {
                    state: {
                        inactivityLogoutMessage: lexico.trc('Inactivity logout message', "You've been logged out due to inactivity, please login again"),
                    },
                }
                : {});
        }
    }
    (0, react_1.useEffect)(() => {
        if (!isLoading && !isSuccess && userData?.userId) {
            void logoutApp();
        }
    }, [isLoading, isSuccess, userData?.userId]);
    (0, react_1.useEffect)(() => {
        if (userSelectedTeamData &&
            userSelectedTeamData.length > 0 &&
            !userSelectedTeamData.includes(userDataFromZustand.userSelectedTeam)) {
            setUserSelectedTeam(userSelectedTeamData[0] || '');
        }
    }, [userDataFromZustand.userSelectedTeam, userSelectedTeamData]);
    (0, react_1.useEffect)(() => {
        if (userData &&
            userData.userId &&
            (userDataFromZustand.userId !== userData.userId || userDataFromZustand.avatarUrl !== userData.avatarUrl)) {
            setUser(userData);
            setCompanyName(userData.companyName);
            setCompanyId(userData.companyAccountId);
        }
    }, [userData, userDataFromZustand.avatarUrl, userDataFromZustand.userId]);
    (0, react_1.useEffect)(() => {
        let cleanup;
        const handleClick = (event) => {
            // we select the hamburger menu defined in angularjs using ts.ui
            if (event.target.closest('.ts-app .ts-headerbar .ts-button')) {
                event.preventDefault();
                openSideMenuOnMobileView(true);
            }
        };
        const attachEventListener = () => {
            const headerElement = document.querySelector('.ts-app .ts-headerbar .ts-button');
            if (headerElement) {
                headerElement.addEventListener('click', handleClick);
                cleanup = () => {
                    headerElement.removeEventListener('click', handleClick);
                };
            }
        };
        const observerCallback = () => {
            if (isMobileWidth) {
                attachEventListener();
            }
        };
        const observer = new MutationObserver(observerCallback);
        observer.observe(document, { childList: true, subtree: true });
        const handleResize = () => {
            if (isMobileWidth) {
                attachEventListener();
            }
        };
        window.addEventListener('resize', handleResize);
        return () => {
            cleanup?.();
            observer.disconnect();
            window.removeEventListener('resize', handleResize);
        };
    }, [openSideMenuOnMobileView, isMobileWidth]);
    (0, react_1.useEffect)(() => {
        if (document.hasFocus() && userData?.userId) {
            startInterval();
        }
        const handleFocus = () => startInterval();
        const handleBlur = () => stopInterval();
        window.addEventListener('focus', handleFocus);
        window.addEventListener('blur', handleBlur);
        return () => {
            stopInterval();
            window.removeEventListener('focus', handleFocus);
            window.removeEventListener('blur', handleBlur);
        };
    }, [userData]);
    const openUserDetailsAside = (0, react_1.useCallback)(() => {
        setOpenAside(true);
    }, []);
    const closeUserDetailsAside = () => {
        setOpenAside(false);
        if (userData) {
            setUser(userData);
        }
    };
    const sideMenuCLassNames = (0, classnames_1.default)({
        [uiConstants_1.UI_SIDE_MENU]: true,
        [uiConstants_1.UI_SIDE_MENU_COLLAPSED]: isOpenOnDesktopView !== undefined && !isOpenOnDesktopView && !isMobileWidth,
        [uiConstants_1.UI_SIDE_MENU_OPEN]: isOpenOnDesktopView === undefined || isOpenOnDesktopView || isMobileWidth,
        [uiConstants_1.UI_SIDE_MENU_MOBILE_VIEW_OPEN]: isOpenOnMobileView && isMobileWidth,
    });
    return isSuccess && shouldRender ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", { id: appConstants_1.sideMenuConstants.sideMenuId, className: sideMenuCLassNames, "data-testid": "side-menu", children: [(0, jsx_runtime_1.jsx)(sideMenuHeader_1.default, {}), (0, jsx_runtime_1.jsx)(sideMenuPanel_1.default, {}), (0, jsx_runtime_1.jsx)(sideMenuFooter_1.default, { openUserDetailsAside: openUserDetailsAside }), (0, jsx_runtime_1.jsx)(sideMenuTeamSwitcher_1.default, {}), (0, jsx_runtime_1.jsx)(sideMenuMyRequestAside_1.default, {})] }), (0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)("div", {}), children: (0, jsx_runtime_1.jsx)(UserDetailsAside, { openUserDetailsAside: openAside, closeUserAside: closeUserDetailsAside }) })] })) : null;
};
exports.default = SideMenu;
